// ------------------------------------------------------------------------------
// <auto-generated>
// This code was generated by the @augloop/code-gen tool.
// Source: https://dev.azure.com/office/ISS/_git/augloop-server?path=%2Fmodules%2Ftypes-core%2Fsrc%2Fsignals.ts
// Changes to this file may cause incorrect behavior and will be lost upon regeneration.
// </auto-generated>
// ------------------------------------------------------------------------------

import { ISignal } from '../signals';
import { ISchemaObject, SchemaObjectHeader } from '../schema-object';
import { SchemaObject } from './schema-object.g';

export class Signal implements ISignal {
    public targetObject?: ISchemaObject;
    public timestamp?: number;
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: ISignal) {
        SchemaObject.assign(Signal, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Signals_Signal';
    }
    public static getBaseTypes(): string[] {
        return [];
    }
    public static readonly H_ = { T_: Signal.getTypeName(), B_: Signal.getBaseTypes() };
}

